import {SET_LOCALE} from "../constants";

const initialState = {
    "id": 1,
    "abbreviation": "fa-IRx",
    "translation": {
        "Pages": {
            "Register": {
                "Register": {
                    "Title": "ورود",
                    "Mobile": "تلفن همراه",
                    "Submit": "ورود / ثبت نام"
                },
                "Verify": {
                    "Title": "تایید ورود",
                    "VerifyCode": "کد تایید",
                    "FullName": "نام و نام خانوادکی",
                    "SendTo": "کد تایید شما به شماره موبایل {{0}} ارسال شد.",
                    "TimeToSend": "زمان تا ارسال مجدد",
                    "SendAgain": "ارسال مجدد",
                    "Submit": "تایید",
                    "Back": "بازگشت"
                }
            },
            "App": {
                "Layout": {
                    "Header": {
                        "Welcomes": {
                            "GoodMorning": "صبح بخیر",
                            "GoodAfternoon": "عصر بخیر",
                            "GoodEvening": "شب بخیر"
                        },
                        "SampleUserName": "کاربر عزیز",
                        "Back": "بازگشت"
                    },
                    "Footer": {
                        "Menu": {
                            "Main": "صفحه اصلی",
                            "Profile": "پروفایل",
                            "Admin": "مدیریت"
                        }
                    }
                },
                "Account": {
                    "Title": "پروفایل کاربری",
                    "Mobile": "تلفن همراه",
                    "FullName": "نام و نام خانوادگی",
                    "SignOut": "خروج"
                },
                "Home": {
                    "Price": "تعرفه دوره",
                    "Currency": "تومان",
                    "ExpireTime": "مدت زمان دوره",
                    "Days": "روز",
                    "CourseStatus": {
                        "InActive": "غیر فعال",
                        "Active": "فعال",
                        "FullCapacity": "تکمیل ظرفیـت",
                        "Canceled": "لغو شده",
                        "CommingSoon": "به زودی ...",
                        "Draft": "پیش نویس"
                    }
                },
                "Course": {
                    "Tabs": {
                        "Info": "اطلاعات",
                        "Students": "هنرجویان",
                        "Lessons": "آموزش",
                        "Levels": "آزمون"
                    },
                    "Info": {
                        "RegisterDate": "تاریخ ثبت نام",
                        "ExpireDate": "تاریخ انقضا",
                        "NotRegistered": "ثبت نام انجام نشده است.",
                        "Expired": "منقضی شده",
                        "ExpiredDescription": "مهلت شرکت در این دوره به پایان رسیده است و جهت تمدید دوره می بایست هزینه تمدید دوره پرداخت گردد.",
                        "Days": "روز",
                        "TotalLevels": "کل آزمون ها",
                        "PassedLevels": "آزمون های گذرانده شده",
                        "Levels": "آزمون",
                        "Price": "تعرفه دوره",
                        "RenewalPrice": "تعرفه تمدید دوره",
                        "Currency": "تومان",
                        "Description": "توضیحات",
                        "Register": "ثبت نام دوره",
                        "Policy": "حقوق انحصاری",
                        "PolicyContent": "هر گونه كپي برداري و نشر هر گونه محتوا ،فيلم و عكس از اين اپليكيشن ،در فضاي مجازي و غير مجازي ،پيگرد قانوني دارد.",
                        "AgreePolicy": "مورد تایید است"
                    },
                    "Student": {
                        "State": {
                            "Graduated": "فارغ التحصیل",
                            "Pending": "انتظار بررسی"
                        }
                    },
                    "Level": {
                        "State": {
                            "Active": "فعال",
                            "Done": "پاس",
                            "Pending": "بررسی",
                            "Lock": "قفل"
                        }
                    }
                },
                "Lesson": {
                    "Tabs": {
                        "Main": "دوره",
                        "Sub": "زیر دوره"
                    },
                    "Main": {
                    },
                    "Sub": {
                    }
                },
                "Level": {
                    "UploadContent": "بارگزاری محتوا",
                    "ContentTypes": {
                        "Image": "تصویر"
                    },
                    "ConfirmDialog": {
                        "Title": "تایید",
                        "Content": "جهت تایید نهایی اطلاعات و ارسال برای بررسی اطمینان دارید؟"
                    },
                    "Footer": {
                        "Pending": "اطلاعات شما جهت بررسی برای مستر ارسال شده است. \n تا بررسی و پاسخگویی صبور باشید.",
                        "Done": "آزمون به اتمام رسیده است.",
                        "PlaceHolder": "پیام خود را وارد نمایید..."
                    }
                },
                "PaymentResult": {
                    "Loading": "بارگیری اطلاعات...",
                    "SucceedPayment": "عملیات پرداخت با موفقیت انجام شد.",
                    "TrackingCode": "شماره پیگیری",
                    "UnSucceedPayment": "عملیات پرداخت با خطا همراه بود.",
                    "ContactUs": "با مدیر سیست تماس حاصل کنید.",
                    "Return": "بازگشت به برنامه"
                },
                "CourseRegistration": {
                    "Title": "ثبت نام دوره",
                    "Description": "اطلاعات پرداختی خود را جهت بررسی و ثبت نام در دوره وارد نمایید.",
                    "CardNumber": "شماره کارت",
                    "CardOwner": "نام صاحب کارت",
                    "TrackingCode": "کد پیگیری تراکنش",
                    "PendingDesc": "اطلاعات شما جهت بررسی برای مدیر ارسال شده است.",
                    "Submit": "ثبت",
                    "Edit": "ویرایش"
                }
            },
            "Admin": {
                "Level": {
                    "UploadContent": "بارگزاری محتوا",
                    "ContentTypes": {
                        "Image": "تصویر",
                        "Movie": "فیلم"
                    },
                    "SubmitContent": "تایید / عدم تایید",
                    "Approve": "تایید",
                    "DisApprove": "عدم تایید",
                    "ConfirmDialog": {
                        "Title": "تایید",
                        "Content": "جهت تایید نهایی اطلاعات و ارسال برای بررسی اطمینان دارید؟"
                    },
                    "Footer": {
                        "Pending": "اطلاعات شما جهت بررسی برای مستر ارسال شده است. \n تا بررسی و پاسخگویی صبور باشید.",
                        "Done": "آزمون به اتمام رسیده است.",
                        "PlaceHolder": "پیام خود را وارد نمایید..."
                    },
                    "ModalTypes": {
                        "Approve": {
                            "Title": "تایید",
                            "Content": "جهت عملیات تایید اطمینان دارید؟"
                        },
                        "DisApprove": {
                            "Title": "عدم تایید",
                            "Content": "جهت عملیات عدم تایید اطمینان دارید؟"
                        }
                    }
                },
                "Main": {
                    "MenuItems": {
                        "Bills": "گزارش پرداخت ها",
                        "CMS": "مدیریت محتوا"
                    }
                },
                "Bill": {
                    "Main": {
                        "Filter": "فیلتر",
                        "Username": "نام کاربری",
                        "UserFullName": "نام خریدار",
                        "CourseName": "نام دوره",
                        "Step": "وضعیت سفارش",
                        "PaymentType": "نوع پرداخت",
                        "Submit": "اعمال",
                        "Cancel": "انصراف"
                    },
                    "Details": {
                        "Username": "نام کاربری",
                        "UserFullName": "نام و نام خانوادگی",
                        "Price": "مبلغ",
                        "Currency": "تومان",
                        "PaymentType": "نوع پرداخت",
                        "OwnerName": "صاحب حساب",
                        "CardNumber": "شماره کارت",
                        "TrackingCode": "کد پیگیری",
                        "CreatedDate": "تاریخ ایجاد",
                        "ModifiedDate": "تاریخ ویرایش",
                        "OrderStep": "وضعیت سفارش",
                        "Submit": "ثبت",
                        "Back": "بازگشت"
                    },
                    "Steps": {
                        "InProgress": "در سبد خرید",
                        "PaymentProgress": "در حال پرداخت",
                        "SucceedPayment": "پرداخت موفق",
                        "UnSucceedPayment": "پرداخت نا موفق",
                        "Pending": "در انتظار تایید",
                        "NotApproved": "عدم تایید"
                    },
                    "PaymentTypes": {
                        "Online": "آنلاین",
                        "Offline": "آفلاین"
                    },
                    "Currency": "تومان"
                },
                "CMS": {
                    "Info": {
                        "Title": "عنوان",
                        "Summary": "خلاصه",
                        "Price": "تعرفه دوره",
                        "RenewalPrice": "تعرفه تمدید دوره",
                        "Currency": "تومان",
                        "ExpireDate": "مدت انقضا (روز)",
                        "State": "وضعیت دوره",
                        "Description": "توضیحات",
                        "Submit": "ثبت",
                        "Delete": "حذف دوره",
                        "DeleteConfirmDialog": {
                            "Title": "حذف دوره",
                            "Content": "آیا جهت حذف دوره اطمینان دارید؟"
                        }
                    },
                    "Course": {
                        "Title": "مدیریت دوره ها",
                        "Price": "تعرفه دوره",
                        "Currency": "تومان",
                        "ExpireTime": "مدت زمان دوره",
                        "Days": "روز",
                        "CourseStatus": {
                            "InActive": "غیر فعال",
                            "Active": "فعال",
                            "FullCapacity": "تکمیل ظرفیـت",
                            "Canceled": "لغو شده",
                            "CommingSoon": "به زودی ...",
                            "Draft": "پیش نویس"
                        },
                        "Create": "ایجاد دوره",
                        "CourseName": "نام دوره",
                        "CreateDialog": {
                            "Submit": "ایجاد",
                            "Cancel": "انصراف"
                        }
                    },
                    "Lesson": {
                        "Create": "ایجاد آموزش",
                        "LessonName": "عنوان آموزش",
                        "Description": "توضیحات",
                        "NoDescription": "توضیحاتی وارد نشده است.",
                        "CreateDialog": {
                            "Submit": "ایجاد",
                            "Cancel": "انصراف"
                        },
                        "Tabs": {
                            "Main": "دوره",
                            "Sub": "زیر دوره"
                        },
                        "Main": {
                            "Create": "افزودن"
                        },
                        "Sub": {
                            "Create": "افزودن زیر دوره",
                            "SubLessonName": "عنوان زیر دوره",
                            "CreateDialog": {
                                "Submit": "ثبت",
                                "Cancel": "انصراف"
                            }
                        },
                        "Detail": {
                            "ContentType": "نوع داده",
                            "Content": "محتوا",
                            "Priority": "اولویت",
                            "DetectedFile": "فایل شناسایی شد.",
                            "FileSize": "حجم فایل",
                            "UploadVideo": "بارگزاری فیلم",
                            "Submit": "ثبت",
                            "Cancel": "بازگشت"
                        },
                        "ConfirmDialog": {
                            "Title": "حذف",
                            "Content": "آیا جهت حذف این آیتم اطمینان دارید؟"
                        },
                        "Setting": {
                            "Title": "عنوان آموزش",
                            "Priority": "اولویت",
                            "Submit": "ثبت",
                            "Delete": "حذف",
                            "Cancel": "بازگشت",
                            "DeleteConfirmDialog": {
                                "Title": "حذف",
                                "Content": "جهت احذف این آموزش اطمینان دارید؟",
                                "Submit": "ثبت",
                                "Cancel": "انصراف"
                            }
                        }
                    },
                    "Level": {
                        "Create": "ایجاد آزمون",
                        "LevelName": "عنوان آزمون",
                        "Description": "توضیحات",
                        "NoDescription": "توضیحاتی وارد نشده است.",
                        "CreateDialog": {
                            "Submit": "ثبت",
                            "Cancel": "انصراف"
                        },
                        "Detail": {
                            "UploadContent": "بارگزاری محتوا",
                            "ContentTypes": {
                                "Image": "تصویر",
                                "Movie": "فیلم"
                            },
                            "Footer": {
                                "Pending": "اطلاعات شما جهت بررسی برای مستر ارسال شده است. \n تا بررسی و پاسخگویی صبور باشید.",
                                "Done": "آزمون به اتمام رسیده است.",
                                "PlaceHolder": "پیام خود را وارد نمایید..."
                            },
                            "DeleteConfirmDialog": {
                                "Title": "حذف",
                                "Content": "جهت حذف آیتم اطمینان دارید؟"
                            }
                        },
                        "Setting": {
                            "Title": "عنوان آزمون",
                            "Submit": "ثبت",
                            "Delete": "حذف",
                            "Cancel": "بازگشت",
                            "DeleteConfirmDialog": {
                                "Title": "حذف",
                                "Content": "جهت احذف این آزمون اطمینان دارید؟",
                                "Submit": "ثبت",
                                "Cancel": "انصراف"
                            }
                        }
                    }
                }
            },
            "OS": {
                "Android": {
                    "AppName": "می آکادمی",
                    "Description": "لطفا جهت استفاده از اپلیکیشن {{0}} با تجربه کاربری بهتر، اپلیکیشن اندرویدی ما را دانلود کنید.",
                    "Download": "دانلود {{0}}",
                    "Web": "استفاده در حالت وب"
                },
                "IOS": {
                    "AppName": "می آکادمی",
                    "Description": "اپلیکیشن {{0}} را به صفحه موبایل خود اضافه کنید.",
                    "FirstStep": "1- از نوار پایین دکمه {{0}} را انتخاب کنید.",
                    "SecondStep": "2- منوی باز شده را به چپ بکشید و گزینه {{0}} را انتخاب کنید.",
                    "ThirdStep": "3- در مرحله بعد در قسمت بالای صفحه روی {{0}} کلیک کنید.",
                    "Web": "استفاده در حالت وب",
                    "Instagram": {
                        "FirstStep": "1- از بالا و سمت راست صفحه {{0}} را انتخاب کنید.",
                        "SecondStep": "2- از منوی باز شده گزینه {{0}} را انتخاب کنید."
                    }
                }
            }
        },
        "Notifications": {
            "Succeed": "عملیات با موفقیت انجام شد.",
            "WrongParams": "اطلاعات ارسالی فاقد اعتبار می باشد.",
            "WrongData": "اطلاعات ورودی صحیح نمی باشد.",
            "SucceedSubmittedToReview": "اطلاعات جهت بررسی با موفقیت ارسال شد.",
            "ShouldCompletePreviousLevels": "ابتدا آزمون های قبلی می بایست انجام شود.",
            "InActiveLevel": "وضعیت آزمون فعال نیست.",
            "NoAuthenticate": "زمان اعتبار ورود شما به پایان رسیده است.",
            "NoAuthorize": "دسترسی شما به این بخش غیر مجاز می باشد.",
            "ServiceNotFound": "آدرس سرویس یافت نشد.",
            "InternalServerError": "خطایی در سرور رخ داده است.",
            "NotCourseRegistered": "ثبت نام در این دوره انجام نشده است.",
            "LessonNotFoundByThisId": "آموزش با این شناسه یافت نشد.",
            "LevelNotFoundByThisId": "آزمون با این شناسه یافت نشد.",
            "DisableCourse": "وضعیت این دوره فعال نمی باشد.",
            "NotNewToSubmit": "اطلاعات جدیدی جهت ثبت نهایی درج نشده است.",
            "MasterApprove": "اطلاعات شما توسط مدیر سیستم بررسی و تایید شد.",
            "MasterDisApprove": "اطلاعات شما توسط مدیر سیستم بررسی و مورد تایید نمی باشد.",
            "SignInOrSignUpError": "خطایی در ورود یا ایجاد کاربر رخ داده است.",
            "UserNotFound": "کاربر مورد نظر یافت نشد.",
            "InCorrectVerifyCode": "کد تایید وارد شده مورد تایید نیست.",
            "ChangeCourseStateValidationFailed": "امکان تغییر حالت دوره پیش از تکمیل اطلاعات ضروری دوره میسر نیست.",
            "HugeFile": "حجم فایل بارگزاری شده بیش از حد مجاز می باشد.",
            "UnknownException": "خطای شناخته نشده.",
            "SmsServiceError": "خطا در سرویس ارسال پیامک"
        },
        "Components": {
            "NoRecord": {
                "CourseLesson": "برای این دوره آموزشی قرار نگرفته...",
                "MainLesson": "برای این آموزش محتوایی درج نشده است...",
                "SubLesson": "این دوره فاقد زیر دوره می باشد...",
                "CourseLevel": "برای این دوره آزمون درج نشده است...",
                "Level": "این آزمون فاقد اطلاعات می باشد..."
            },
            "Dialog": {
                "Approve": "تایید",
                "Cancel": "انصراف"
            },
            "Payments": {
                "Title": "نحوه پرداخت",
                "Online": {
                    "Title": "پرداخت آنلاین",
                    "Description": "درگاه پرداخت بانک سامان کارت های عضو شتاب و تایید آنی"
                },
                "Offline": {
                    "Title": "پرداخت آفلاین",
                    "Description": "درج فیش واریز و اتنظار تایید مدیر"
                }
            },
            "Select": {
                "CourseState": {
                    "InActive": "غیر فعال",
                    "Active": "فعال",
                    "FullCapacity": "تکمیل ظرفیـت",
                    "Canceled": "لغو شده",
                    "CommingSoon": "به زودی ...",
                    "Draft": "پیش نویس"
                },
                "ContentTypes": {
                    "Text": "متن",
                    "Image": "تصویر",
                    "Video": "فیلم"
                }
            },
            "ActionSheet": {
                "Cancel": "انصراف"
            }
        }
    },
    'rtl': true
};
const locale = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOCALE:
            return action.payload;
        default:
            return state;
    }
};

export default locale;
